import { getTheme } from '@usealloy/component-library';
import React from 'react';

import GlobalStyle from '~/helpers/globalStyle';
import { ThemeContext } from '~/dashboard/context';

import { themes } from './constants';
import type { Themes } from './constants';

type Props = React.PropsWithChildren<{
  theme?: Themes;
}>;

export function ThemeProvider(props: Props) {
  const { children, theme = themes.light } = props;
  const themeContextObj = getTheme(theme);

  return (
    <ThemeContext.Provider value={themeContextObj}>
      <GlobalStyle />
      {children}
    </ThemeContext.Provider>
  );
}
